export const SET_CACHED_IMAGE_URL = 'SET_CACHED_IMAGE_URL'

const setCachedImageUrl = (imageEntitlementToken, imageUrl) => ({
  type: SET_CACHED_IMAGE_URL,
  imageEntitlementToken,
  imageUrl,
})

export { setCachedImageUrl }
